import { useSelector } from "react-redux";

import { useIntl } from "react-intl";

import EntityType from "@mapmycustomers/shared/enum/EntityType";
import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";
import { isEntityTypeSupportingCustomSourceObject } from "@mapmycustomers/shared/util/assert";

import { getSourceObjectValues } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import { getSourceObjectLabel, hasCustomSourceObjects } from "@app/util/ui";

const useSourceObjectLabel = (
  entityType: EntityType | undefined,
  key: HasSourceObject["sourceObject"] | undefined
): string | undefined => {
  const intl = useIntl();
  const values = useSelector((state: RootState) => getSourceObjectValues(state, entityType));
  return hasCustomSourceObjects(values) && isEntityTypeSupportingCustomSourceObject(entityType)
    ? getSourceObjectLabel(intl, entityType, values, key)
    : undefined;
};

export default useSourceObjectLabel;
